import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/reducers";
import { AppDispatch } from "store/store";
import { toggleNetworkHelpDialog } from "store/user/slice";
import styles from "./NetworkHelpDialog.module.css";

export const NetworkHelpDialog: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { networkQuality } = useSelector((s: RootState) => s.user);

  return (
    <div className={styles["container"]}>
      <div className={styles["dialog"]}>
        <div className="mb-4 pl-4 pr-4">
          <p className="lead text-center mb-0">Network Quality</p>
        </div>
        <p className="text-center"><strong>Your network quality is {networkQuality}.</strong></p>

        <p>General Tips</p>
        <ul>
          <li>Avoid activies that require heavy use of your internet connection.</li>
          <li>If you are on Wi-Fi, try moving closer to your router.</li>
        </ul>
        <button
          type="submit"
          className="btn btn-primary btn-block"
          onClick={() => dispatch(toggleNetworkHelpDialog())}
        >
          Close
        </button>
      </div>
    </div>
  );
};
